import PathMatrix from "csi/table/matrix/Path";
import declare from "dojo/_base/declare";

const SRMSupplierAllocationMatrix = declare(PathMatrix, {
	/**
     * @override
     * Filters Supplier Requests that are not under the current SRM and not under the style
     */
	_filterNodes (ctx, spec, nodes) {
		const cache = ctx.cache;
		const parentSRMUrl = ctx.getParentURL();
		const currentStyleUrl = ctx.getNode().$URL;
		return nodes.filter((node) => {
			const lineItems = node.LineItems;
			return lineItems.some((lineItemUrl) => {
				const lineItem = cache.getNode(lineItemUrl);
				return lineItem?.SRLineItemProduct === currentStyleUrl;
			}) && node.__Parent__ === parentSRMUrl;
		});
	},
});

export = SRMSupplierAllocationMatrix;
